import { httpClient } from '@/core/services/http'
import { memoryTokenService } from '@/core/services/tokens/client'
import { createDeleteProfileImageUseCase } from '../usecases/delete-profile.usecase'
import { createUpdatePasswordUseCase } from '../usecases/update-password.usecase'
import { createUpdateProfileUseCase } from '../usecases/update-profile.usecase'

export const updateProfile = createUpdateProfileUseCase({
  httpClient,
  tokenService: memoryTokenService,
})
export const updatePassword = createUpdatePasswordUseCase({
  httpClient,
  tokenService: memoryTokenService,
})
export const deleteProfileImage = createDeleteProfileImageUseCase({
  httpClient,
  tokenService: memoryTokenService,
})
